import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-4c795f8c-1f6c-4c2f-af4a-d509c623ba1c-__Glyph",
  "enable-background": "new 0 0 32 32",
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "ec-ac6b96ba-4337-42d9-b600-de00b6976335-__XMLID_294_",
      d: "M 393.846 512 C 393.846 577.142 446.858 630.154 512 630.154 C 577.142 630.154 630.154 577.142 630.154 512 C 630.154 446.858 577.142 393.846 512 393.846 C 446.858 393.846 393.846 446.858 393.846 512 Z"
    }, null, -1),
    _createElementVNode("path", {
      id: "ec-a2c06a51-1b33-4739-bedb-afb3d0f7af2d-__XMLID_295_",
      d: "M 393.846 905.846 C 393.846 970.988 446.858 1024 512 1024 C 577.142 1024 630.154 970.988 630.154 905.846 C 630.154 840.704 577.142 787.692 512 787.692 C 446.858 787.692 393.846 840.704 393.846 905.846 Z"
    }, null, -1),
    _createElementVNode("path", {
      id: "ec-b9b6da8f-04e2-4323-b0ba-033326bec814-__XMLID_297_",
      d: "M 393.846 118.154 C 393.846 183.296 446.858 236.308 512 236.308 C 577.142 236.308 630.154 183.296 630.154 118.154 C 630.154 53.012 577.142 0 512 0 C 446.858 0 393.846 53.012 393.846 118.154 Z"
    }, null, -1)
  ]))]))
}
export default { render: render }